import { render, staticRenderFns } from "./InterestCard.vue?vue&type=template&id=48bf46e0&"
import script from "./InterestCard.controller.js?vue&type=script&lang=js&"
export * from "./InterestCard.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./InterestCard.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "6501d009"
  
)

export default component.exports